import React, { useState } from 'react';
import './MonthYearPicker.css';

// Month picker that reuses the app calendar's month-grid design/logic
// (same visual + behaviour as DatePickerCombined's "Month" tab in SalesReport.js):
// a year header with ‹ › navigation and a 3-column grid of months, with the current
// month highlighted and future months disabled.
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default function MonthYearPicker({ isOpen, onClose, selected, onSelect, maxMonth }) {
  const initYear = selected ? parseInt(selected.slice(0, 4), 10) : new Date().getFullYear();
  const [viewYear, setViewYear] = useState(initYear);

  if (!isOpen) return null;

  const now = new Date();
  const curMonth = now.getMonth();
  const curYear = now.getFullYear();
  const [maxY, maxM] = (maxMonth || `${curYear}-${String(curMonth + 1).padStart(2, '0')}`).split('-').map(Number);
  const selYear = selected ? parseInt(selected.slice(0, 4), 10) : -1;
  const selMonthIdx = selected ? parseInt(selected.slice(5, 7), 10) - 1 : -1;

  const pick = (i) => {
    onSelect(`${viewYear}-${String(i + 1).padStart(2, '0')}`);
    onClose();
  };

  return (
    <div className="myp-overlay" onClick={onClose}>
      <div className="myp-popup" onClick={(e) => e.stopPropagation()}>
        <div className="myp-header">
          <button type="button" onClick={() => setViewYear((y) => y - 1)} aria-label="Previous year">‹</button>
          <h3>{viewYear}</h3>
          <button type="button" onClick={() => setViewYear((y) => y + 1)} disabled={viewYear >= maxY} aria-label="Next year">›</button>
        </div>
        <div className="myp-grid">
          {MONTHS.map((m, i) => {
            const isFuture = viewYear > maxY || (viewYear === maxY && i > maxM - 1);
            const isSelected = viewYear === selYear && i === selMonthIdx;
            const isCurrent = viewYear === curYear && i === curMonth;
            return (
              <button
                key={m}
                type="button"
                disabled={isFuture}
                className={`myp-cell${isSelected ? ' myp-selected' : ''}${isCurrent ? ' myp-current' : ''}`}
                onClick={() => !isFuture && pick(i)}
              >
                {m.substring(0, 3)}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
